export function printStack() {
    try {
        const callstack = new Error().stack.split("\n");
        let matchArray = callstack[3].match(/at (.+?) (\(.+?\))/)
        if (!matchArray) return
        const location = matchArray[2]
        return location
    } catch (error) {
        return ''
    }
}